/**
 * TagIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const TagIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M17.782 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path
      fillRule="evenodd"
      d="M12.992 2h7.29a1.5 1.5 0 0 1 1.5 1.5v7.29a1.5 1.5 0 0 1-.44 1.06L12.192 21a2 2 0 0 1-2.82 0l-6.59-6.59a2 2 0 0 1 0-2.82l9.15-9.15a1.5 1.5 0 0 1 1.06-.44m-2.21 17.59 9-9V4h-6.59l-9 9z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const TagIcon = makeIcon('TagIcon', TagIconSvg)
